import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import router from './router'
import { firestorePlugin } from 'vuefire'
import * as firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/firestore'
import 'firebase/auth'
import { store } from './store.ts'

Vue.config.productionTip = false

Vue.use(firestorePlugin)

new Vue({
  vuetify,
  router,
  store: store,
  render: h => h(App)
}).$mount('#app')

const firebaseConfig = {
  apiKey: "AIzaSyBAWr0-SS-bXleRGjR6VMNPedhKNwAWfwM",
  authDomain: "novelreviewers-1550198142897.firebaseapp.com",
  databaseURL: "https://novelreviewers-1550198142897.firebaseio.com",
  projectId: "novelreviewers-1550198142897",
  storageBucket: "novelreviewers-1550198142897.appspot.com",
  messagingSenderId: "1030885888139",
  appId: "1:1030885888139:web:75cf2b028213d64a7c848e",
  measurementId: "G-D83QR7KMKB"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
firebase.analytics();
export const db = firebase.firestore()

if (process.env.NODE_ENV === 'development') {
  db.settings({
    host: 'localhost:5000',
    ssl: false
  })
}

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
})